import HoldingReportRepository from "@adapters/repositories/Reports/HoldingReport";
import { downloadReportsRepo } from "../../understandingCommonDI/downloadReportsDI";
import DPTransactionReportRepository from "@adapters/repositories/Reports/DPTransactionReport";
import { accountDetails, qouteStream } from "@di";
import DashboardRepository from "@adapters/repositories/Reports/common/dashboardRepo";
export default (http, infrastructure) => {
    return {
        holdingMainScreenRepo: new HoldingReportRepository(http, accountDetails),
        downloadRepo: downloadReportsRepo,
        quoteStream: qouteStream,
        dpTransactionRepo: new DPTransactionReportRepository(http, accountDetails),
        dashboardRepo: new DashboardRepository(http, accountDetails),
    };
};
